const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/BasicChart"),
    name: "Net Profit vs Cost",
    visible: true,
    props: {
      title: "Net Profit vs Cost",
      type: "doughnut",
      dataCollectionFn: (it) => {
        return {
          labels: ["Net Profit", "Total Cost"],
          datasets: [
            {
              backgroundColor: ["#2196F3", "#26C6DA"],
              data: [
                it && it.profit ? it.profit.netProfit : 0,
                it && it.profit ? it.profit.totalCost : 0,
              ],
            },
          ],
        };
      },
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/BasicChart"),
    name: "Profitability",
    visible: true,
    props: {
      title: "Profitability",
      type: "bar",
      dataCollectionFn: (it) => {
        return {
          labels: ["Margin", "Markup"],
          datasets: [
            {
              label: "%",
              backgroundColor: ["#90A4AE", "#FF6E40"],
              data: [
                it && it.profit ? it.profit.margin : 0,
                it && it.profit ? it.profit.markup : 0,
              ],
            },
          ],
        };
      },
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/BasicChart"),
    name: "Commission and Net Profit",
    visible: false,
    props: {
      title: "Commission and Net Profit",
      type: "pie",
      dataCollectionFn: (it) => {
        return {
          labels: ["Net Profit", "Commission"],
          datasets: [
            {
              backgroundColor: ["#FF4081", "#26C6DA"],
              data: [
                it && it.profit ? it.profit.netProfit : 0,
                it && it.profit ? it.profit.commission : 0,
              ],
            },
          ],
        };
      },
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/BasicChart"),
    name: "Markup by Supplier",
    visible: false,
    props: {
      title: "Markup by Supplier",
      type: "pie",
      dataCollectionFn: (it) => {
        const markupBySupplier = it.items.edges.reduce((h, item) => {
          h[item.node.supplierName] = item.node.markup;
          return h;
        }, {});
        return {
          labels: Object.keys(markupBySupplier),
          datasets: [
            {
              backgroundColor: [
                "#2196F3",
                "#26C6DA",
                "#69F0AE",
                "#FF4081",
                "#90CAF9",
                "#D4E157",
                "#43A047",
                "#18FFFF",
                "#F9A825",
                "#A1887F",
                "#90A4AE",
                "#FF6E40",
                "#E040FB",
              ],
              data: Object.values(markupBySupplier),
            },
          ],
        };
      },
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/BasicChart"),
    name: "Profit by Supplier",
    visible: true,
    props: {
      title: "Profit by Supplier",
      type: "pie",
      dataCollectionFn: (it) => {
        const profitBySupplier = it.items.edges.reduce((h, item) => {
          h[item.node.supplierName] =
            Number(item.node.totalSellInBase) -
            Number(item.node.totalCostInBase);
          return h;
        }, {});

        return {
          labels: Object.keys(profitBySupplier),
          datasets: [
            {
              backgroundColor: [
                "#43A047",
                "#18FFFF",
                "#F9A825",
                "#A1887F",
                "#2196F3",
                "#26C6DA",
                "#69F0AE",
                "#FF4081",
                "#90CAF9",
                "#D4E157",
                "#90A4AE",
                "#FF6E40",
                "#E040FB",
              ],
              data: Object.values(profitBySupplier),
            },
          ],
        };
      },
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/itineraries/details-charts/index.js